// extracted by mini-css-extract-plugin
export default {"container":"reset-password_container__NGk4k","subcontainer":"reset-password_subcontainer__1r86P","noFormSubcontainer":"reset-password_noFormSubcontainer__JkLpv"};